import styled from "styled-components";

interface IContainerProps {
  $padding?: number;
}

export const Container = styled.div<IContainerProps>`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding-top: ${({ $padding }) => ($padding ? `${$padding}px` : '0')};

  .title {
    font-size: 12px;
    font-weight: 600;
    line-height: normal;
    text-align: center;
    margin-top: 24px;
    color: ${({ theme }) => theme.colors.surface.onSurface};
  }

  .description {
    font-size: 12px;
    font-weight: 400;
    line-height: normal;
    text-align: center;
    margin-top: 6px;
    color: ${({ theme }) => theme.colors.surface.onSurfaceVariant};
  }
`;
